import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparativa() {
  const rows = [{
    bad: 'Tardás horas armando material para cada clase',
    good: 'Material listo para usar en cada clase'
  }, {
    bad: 'Sin progresión didáctica clara para tus alumnos',
    good: 'Progresión didáctica de cero a avanzado'
  }, {
    bad: 'Material genérico que no es LSA argentino',
    good: '100% LSA argentino 2026'
  }, {
    bad: 'Sin diccionario visual de consulta rápida',
    good: 'Diccionario visual de 500+ señas siempre disponible'
  }, {
    bad: 'Cada alumno nuevo significa empezar de cero',
    good: 'Sistema replicable para todos tus alumnos'
  }];
  return <section className="bg-white text-lsa-dark py-12 px-5" data-id="element-51">
      <div className="max-w-xl mx-auto" data-id="element-52">
        <h2 className="text-[22px] font-bold text-center mb-8 leading-tight" data-id="element-53">
          Sin LSA Fácil para Profesores vs. Con LSA Fácil para Profesores
        </h2>

        <div className="border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-54">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-55">
            <div className="p-4 flex items-center justify-center gap-2 font-bold text-red-600 text-sm sm:text-base" data-id="element-56">
              <X size={18} strokeWidth={3} data-id="element-57" /> Sin LSA Fácil
            </div>
            <div className="p-4 flex items-center justify-center gap-2 font-bold text-lsa-celeste text-sm sm:text-base border-l border-gray-200 bg-lsa-light" data-id="element-58">
              <Check size={18} strokeWidth={3} data-id="element-59" /> Con LSA Fácil
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-60">
            {rows.map((row, index) => <div key={index} className="grid grid-cols-2 text-[13px] sm:text-[14px]" data-id="element-61">
                <div className="p-4 text-gray-600 pr-6" data-id="element-62">{row.bad}</div>
                <div className="p-4 font-medium text-lsa-dark border-l border-gray-100 bg-lsa-light/30 pl-6" data-id="element-63">
                  {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}